module.exports = __webpack_public_path__ + "static/dna-99202185dbbf269668072a830e16af25.png";